'use client';

import { c as _c } from "react/compiler-runtime";
import { CountrySelectorButton } from '@sprd/spreadshirt-shell';
import { useSetAtom } from 'jotai';
import { useLocale, useTranslations } from 'next-intl';
import { countrySwitcherAtom } from '@/store/atoms';
import { countryLabel, countryOptionFor } from './CountryOptions';
export const ShopCountryButton = () => {
  const $ = _c(11);
  const setOpen = useSetAtom(countrySwitcherAtom);
  const locale = useLocale();
  const t = useTranslations();
  let t0;
  if ($[0] !== locale) {
    t0 = countryOptionFor(locale);
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const current = t0;
  let t1;
  if ($[2] !== locale || $[3] !== t) {
    t1 = t("countrySwitcher.change", {
      country: countryLabel(locale)
    });
    $[2] = locale;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== setOpen) {
    t2 = () => setOpen(true);
    $[5] = setOpen;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== current || $[8] !== t1 || $[9] !== t2) {
    t3 = <CountrySelectorButton country={current} aria-label={t1} onClick={t2} />;
    $[7] = current;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};